// Iter 136 — Wall-clock time helpers.
//
// Convention: every `starts_at` / slot ISO string in this app is a
// CLINIC-LOCAL wall time (tagged +00:00 for legacy reasons). Never run
// them through `new Date(...).toLocale*()` — that converts using the
// device timezone and shows the wrong hour on any non-UTC device.
// Instead parse the clock fields straight out of the string.

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
const WEEKDAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

export function wallParts(iso) {
  if (!iso || typeof iso !== 'string' || iso.length < 16) return null;
  return {
    y: parseInt(iso.slice(0, 4), 10),
    m: parseInt(iso.slice(5, 7), 10),
    d: parseInt(iso.slice(8, 10), 10),
    hh: parseInt(iso.slice(11, 13), 10),
    mm: parseInt(iso.slice(14, 16), 10),
  };
}

export function wallTime(iso, clock = '24h') {
  const p = wallParts(iso);
  if (!p) return '';
  const mm = String(p.mm).padStart(2, '0');
  if (clock === '12h') {
    const ampm = p.hh >= 12 ? 'PM' : 'AM';
    const h12 = p.hh % 12 || 12;
    return `${h12}:${mm} ${ampm}`;
  }
  return `${String(p.hh).padStart(2, '0')}:${mm}`;
}

export function wallDate(iso) {
  const p = wallParts(iso) || wallParts(iso + 'T00:00');
  if (!p) return '';
  const dt = new Date(p.y, p.m - 1, p.d);
  return `${WEEKDAYS[dt.getDay()]}, ${MONTHS[p.m - 1]} ${p.d}, ${p.y}`;
}

export function wallDateTime(iso, clock = '24h') {
  const dpart = wallDate(iso);
  const t = wallTime(iso, clock);
  return t ? `${dpart} · ${t}` : dpart;
}

export function wallHour(iso) {
  const p = wallParts(iso);
  return p ? p.hh : 0;
}

export function wallDay(iso) {
  return (iso || '').slice(0, 10);
}

// 'YYYY-MM-DD' for a JS Date using LOCAL calendar fields (never toISOString —
// that shifts the day near midnight on non-UTC devices).
export function localDateStr(d = new Date()) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// 'YYYY-MM-DDTHH:MM' for datetime-local inputs, from local calendar fields.
export function localInputValue(d = new Date()) {
  return `${localDateStr(d)}T${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}
